import Timer from '../../../utils/timer';
import {useState, useEffect} from 'react';

export default ({timestamp, children}) => {
    const [time, setTime] = useState(timestamp),
          timer = Timer.parse(time, true);

    useEffect(() => {
        window.testYourLuckTimerTimeout = setTimeout(setTime, 500, time - 500);
        return () => clearTimeout(window.testYourLuckTimerTimeout)
    }, [time]);

    if(time <= 0)
        return children;

    return (
        <>
            <div className="button" style={{
                opacity: 0.7,
                cursor: 'no-drop'
            }}>
                {timer.hours}:{timer.minutes}:{timer.seconds}
            </div>
            <div className="status">
                You can use this bonus every<br/><b>8 hours</b>
            </div>
        </>
    )
}